export default {
  custom_additive: {
    placeholder: 'Ajouter une option personnalisée',
  },
  buttons: {
    add: 'Ajouter',
  },
};
